import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { AuthProvider } from '@/lib/auth';
import { ReservationProvider } from '@/lib/reservation';
import AdminProtectedRoute from '@/components/admin/AdminProtectedRoute';

// Public pages
import HomePage from '@/pages/public/Home';
import AtraccionesPage from '@/pages/public/Atracciones';
import CumpleanosEventosPage from '@/pages/public/CumpleanosEventos';
import NosotrosPage from '@/pages/public/Nosotros';
import ContactoPage from '@/pages/public/Contacto';
import PoliticaPrivacidadPage from '@/pages/public/PoliticaPrivacidad';
import NormativasParquePage from '@/pages/public/NormativasParque';

// Admin pages
import AdminLoginPage from '@/pages/admin/Login';
import AdminDashboardPage from '@/pages/admin/Dashboard';
import AdminLeadsPage from '@/pages/admin/Leads';
import AdminReservationsPage from '@/pages/admin/Reservations';
import AdminAttractionsPage from '@/pages/admin/Attractions';
import AdminEventsPage from '@/pages/admin/Events';
import AdminContentPage from '@/pages/admin/Content';
import AdminMediaPage from '@/pages/admin/Media';
import AdminSocialPage from '@/pages/admin/Social';
import AdminSettingsPage from '@/pages/admin/Settings';
import AdminAnalyticsPage from '@/pages/admin/Analytics';
import AdminActivityPage from '@/pages/admin/ActivityLog';
import AdminBackupPage from '@/pages/admin/Backup';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <ReservationProvider>
                        <Routes>
                            {/* Public */}
                            <Route path="/" element={<HomePage />} />
                            <Route path="/atracciones" element={<AtraccionesPage />} />
                            <Route path="/cumpleanos-y-eventos" element={<CumpleanosEventosPage />} />
                            <Route path="/nosotros" element={<NosotrosPage />} />
                            <Route path="/contacto" element={<ContactoPage />} />
                            <Route path="/politica-de-privacidad" element={<PoliticaPrivacidadPage />} />
                            <Route path="/normativas-del-parque" element={<NormativasParquePage />} />

                            {/* Admin */}
                            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
                            <Route path="/admin/login" element={<AdminLoginPage />} />
                            <Route path="/admin/dashboard" element={<AdminProtectedRoute><AdminDashboardPage /></AdminProtectedRoute>} />
                            <Route path="/admin/leads" element={<AdminProtectedRoute><AdminLeadsPage /></AdminProtectedRoute>} />
                            <Route path="/admin/reservations" element={<AdminProtectedRoute><AdminReservationsPage /></AdminProtectedRoute>} />
                            <Route path="/admin/attractions" element={<AdminProtectedRoute><AdminAttractionsPage /></AdminProtectedRoute>} />
                            <Route path="/admin/events" element={<AdminProtectedRoute><AdminEventsPage /></AdminProtectedRoute>} />
                            <Route path="/admin/content" element={<AdminProtectedRoute><AdminContentPage /></AdminProtectedRoute>} />
                            <Route path="/admin/media" element={<AdminProtectedRoute><AdminMediaPage /></AdminProtectedRoute>} />
                            <Route path="/admin/social" element={<AdminProtectedRoute><AdminSocialPage /></AdminProtectedRoute>} />
                            <Route path="/admin/settings" element={<AdminProtectedRoute><AdminSettingsPage /></AdminProtectedRoute>} />
                            <Route path="/admin/analytics" element={<AdminProtectedRoute><AdminAnalyticsPage /></AdminProtectedRoute>} />
                            <Route path="/admin/activity" element={<AdminProtectedRoute><AdminActivityPage /></AdminProtectedRoute>} />
                            <Route path="/admin/backup" element={<AdminProtectedRoute><AdminBackupPage /></AdminProtectedRoute>} />

                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </ReservationProvider>
                </AuthProvider>
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
